import { message } from "antd";
import { goToLink, removeUser } from "../../services/authService";
import { postCall } from "../../services/postcall";
import {
  AVATARSAVED,
  AVATARSAVING,
  AVATARUPLOADED,
  AVATARUPLOADING,
  LOADING,
  USER_DATA_LOADED,
  USER_DATA_UPDATED,
} from "./EditProfile.actions";

export default class EditProfileModel {

  public static userDetailsAction() {
    return async (dispatch: any, getState: any) => {
      dispatch({
        type: LOADING
      });
      let result = null;

      try {
        result = await postCall({
          path: '/rpc',
          method: 'POST',
          data: {
            jsonrpc: '2.0',
            method: 'profile.get_profile',
            id: 39405,
            params: {
              profile: {
                id: localStorage.getItem('user'),
              },
            },
            cred: {
              user: localStorage.getItem('user'),
              token: localStorage.getItem('token'),
            },
          }
        });
        console.log(result?.result?.profile)
        let backoffice_operation = result?.result?.profile?.backoffice_operation
        if((backoffice_operation?.userType == 'SELLER' && backoffice_operation?.isGarage != true) || backoffice_operation?.userType == 'LOSS_ADJUSTER' || backoffice_operation?.userType == 'LOSS_ADJUSTER_ASSISTANT' || backoffice_operation?.userType == 'EXTERNAL_LOSS_ADJUSTER'){
          removeUser()
          goToLink(`/login`);
        }
        await localStorage.setItem('testObject', JSON.stringify(result?.result?.profile));
        localStorage.setItem('userName', result?.result?.profile?.name +' '+result?.result?.profile?.surname);
        let isGarageUser = result?.result?.profile?.backoffice_operation?.userType == 'SELLER' && result?.result?.profile?.backoffice_operation?.isGarage == true
        localStorage.setItem('isGarageUser', JSON.stringify(isGarageUser));
        await localStorage.setItem("userDetails", JSON.stringify(result?.result?.profile))
        let permissions = result?.result?.profile?.backoffice_operation?.operations;
				localStorage.setItem('permissions', JSON.stringify(permissions));
        localStorage.setItem('communicationEmail', JSON.stringify(result?.result?.profile?.communication_email))
        localStorage.setItem("employmentPosition", JSON.stringify(result?.result?.profile?.backoffice_operation?.employmentPosition || ''));
        dispatch({
          type: USER_DATA_LOADED,
          payload: result
        });
        return result

      } catch (error: any) {
        message.error("Un expected error")
        // console.log("error: ",error)
        return error

      }


    };
  }

  public static editProfileAction(values: any) {
    return async (dispatch: any, getState: any) => {
      dispatch({
        type: LOADING
      });
      let result = null;
      try {
        result = await postCall({
          path: '/rpc',
          method: 'POST',
          data: {
            jsonrpc: '2.0',
            method: 'profile.update_profile',
            id: 5610,
            params: {
              profile: {
                id: localStorage.getItem('user'),
                "name": values?.name,
                "surname": values?.surname,
                "phone": values?.phone,
              },
              insurer: {
                id: localStorage.getItem("insurerID")
              }
            },
            cred: {
              user: localStorage.getItem('user'),
              token: localStorage.getItem('token'),
            },
          }
        });
        dispatch({
          type: USER_DATA_UPDATED,
          payload: result
        });
        return result
      } catch (error: any) {
        message.error("Un expected error")
        // console.log("error: ",error)
        return error

      }


    };
  }

  public static uploadUserAvatarAction(file: any) {
    return async (dispatch: any, getState: any) => {
      dispatch({
        type: AVATARUPLOADING
      });
      const formData = new FormData();
      formData.append("compress", "true");
      formData.append("type", 'avatars');
      formData.append("insurerID", "");
      formData.append("id", localStorage.getItem('user') || '');
      formData.append("file", file?.file, file?.file?.name);
      let result = null;
      try {
        result = await postCall({
          path: '/upload',
          method: 'POST',
          data: formData
        }, true);
        dispatch({
          type: AVATARUPLOADED,
          payload: result?.result
        });
        return result?.fileName
      } catch (error: any) {
        return error
      }
    };
  }

  public static addAvatarToProfileAction(fileName: string) {
    return async (dispatch: any, getState: any) => {
        dispatch({
            type: AVATARSAVING
        });
        let result = null;
        try {
            result = await postCall({
                path: '/rpc',
                method: 'POST',
                data: {
                    jsonrpc: "2.0",
                    method: "profile.update_profile",
                    cred: {
                        user: localStorage.getItem('user'),
                        token: localStorage.getItem('token'),
                    },
                    id: Math.floor(Math.random()*1000000),
                    params: {
                      profile:{
                        id: localStorage.getItem('user'),
                        avatar: fileName,
                      },
                    }
                }
            });
            dispatch({
                type: AVATARSAVED,
                payload: result?.result
            });
            return result?.result
        } catch (error: any) {
            return error
        }
    };
}
}
